import type { FC } from 'react';
import { PapiGallection } from '@wix/da-papi-types';
import { StudioSection } from '../../../types/store';
import StashFolderHeaderDesktop from '../../stash/FolderHeaderDesktop';
import PublishedFolderHeaderDesktop from '../../published/FolderHeaderDesktop';

interface Props {
  activeSection: StudioSection;
  selectedFolder?: PapiGallection;
}

const StudioFolderHeaderDesktop: FC<Props> = ({ activeSection }) => {
  if (activeSection === StudioSection.STASH) {
    return <StashFolderHeaderDesktop />;
  }
  if (activeSection === StudioSection.PUBLISHED) {
    return <PublishedFolderHeaderDesktop />;
  }

  return null;
};
StudioFolderHeaderDesktop.displayName = 'StudioFolderHeaderDesktop';

export default StudioFolderHeaderDesktop;
